var selectors = {
  permits: '[data-option-handle="is-the-skip-going-to-be-placed-on-a-road"]',
  hirePeriod: '[data-option-handle="hire-period"]',
  note: '[data-product-note]'
}

var bindPermitOptions = function() {
  var $optionsPermit = $(selectors.permits + ' [type="radio"]');

  if ($optionsPermit.length === 0) return;

  var showHideNote = function(value) {
    var $note = $(selectors.permits + ' ' + selectors.note);
    value.toLowerCase() === 'yes' ? $note.show() : $note.hide();
  }

  var councilSkipValue = $(selectors.permits + ' :checked').val();
  showHideNote(councilSkipValue);

  $optionsPermit.on('change', function() {
    showHideNote($(this).val());
  });
}

var bindDurationOptions = function() {
  var $optionsHirePeriod = $(selectors.hirePeriod + ' [type="radio"]');

  if ($optionsHirePeriod.length === 0) return;

  var updateNote = function(value) {
    var $note = $(selectors.permits + ' ' + selectors.note);
    var multiplier = 1;
    var price = $note.data('product-price-2');

    if (value !== 'Up to 14 days') {
      var multiplier = 2;
      var price = $note.data('product-price-4');
    }

    var $price = $note.find('[data-note-price]');
    var $duration = $note.find('[data-note-duration]');

    $price.text(price)
    $duration.text(2 * multiplier)
  }

  var councilSkipValue = $(selectors.hirePeriod + ' :checked').val();
  updateNote(councilSkipValue);

  $optionsHirePeriod.on('change', function() {
    updateNote($(this).val());
  });
}

$(window).load(function() {
  bindPermitOptions();
  bindDurationOptions();


    // Check if cart
    if (!$('body').hasClass('template-cart')) {
        return;
    } else {
        console.log('Is cart');
    }

    function clearCartFunction() {
      console.log('cleared function Called');

      $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function() {
              console.log('I cleared the cart!');

              alert("Same day delivery cut off has passed, your cart has been emptied");

              location.reload();
          },
          dataType: 'json'
      });
    }

    function getNextCutOffTime() {
      var cutOff = new Date();
      cutOff.setHours(14);
      cutOff.setMinutes(16);
      cutOff.setSeconds(0);
      cutOff.setMilliseconds(0);

      return cutOff.getTime();
    }

    function getTimeToCutOffFromNowInMS() {
        return getNextCutOffTime() - new Date().getTime();
    }

    console.log(getTimeToCutOffFromNowInMS());

    var deliveryString = 'Delivery date';

    $.inObject = function(value, obj) {

        var foundKey = null;

        $.each(obj, function(key, val) {


            if (String(val.properties[deliveryString]).includes(value)) {
                foundKey = key;
                return;
            }
        });
        return foundKey;
    };

    var todayLocalString = new Date(Date.now()).toLocaleDateString();

    console.log(todayLocalString);

      $.getJSON("/cart.json", function( cartData ) {
            console.log("Cart json fetched");
        
            // check if any cart items have today's delivery date
            if( $.inObject(todayLocalString, cartData.items) !== null ) {

                // Check if last order is in the past
                if (getTimeToCutOffFromNowInMS() > 0) {

                    console.log('last order is in the future, trigger clear in the future');

                    // Trigger cart to clear at midday
                    setInterval(function() {
                       clearCartFunction();
                    }, getTimeToCutOffFromNowInMS());

                } else{
                  console.log('last order is in the past, trigger clear now');
                  clearCartFunction();
                }

            }

        })
        .fail(function() {
            console.log("Failed to get cart.json");
        });
  
})